<template>
    <div>
        <div class="table-box">
            <div class="search-box">
                <div>
                    <Button type="primary" @click="addStuModel = true;resetAddStuForm('addStuForm')">添加学生</Button>
                </div>
                <div>
                    <Button type="primary" @click="delStu">删除</Button>
                </div>
                <div>
                    <Button type="primary" @click="batchImportModel = true">批量导入</Button>
                </div>
                <div class="search-a">
                    <a :href="download_template">下载批量导入模板</a>
<!--                    <span>（批量导入的学生的初始密码为学生学号）</span>-->
                </div>
            </div>
            <Table ref="selection" :columns="columns" :data="train_class_stu.body" @on-select="tableSelectAll" @on-select-all="tableSelectAll"></Table>
            <div  class="page-box" v-if="train_class_stu.page">
                <Page show-sizer
                      show-total
                      :page-size="train_class_stu.page.page_size"
                      :current="train_class_stu.page.current"
                      :total="train_class_stu.page.count"
                      @on-change="currentPage"
                      @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
        <Modal
                v-model="batchImportModel"
                title="批量导入学生"
                width="400"
                @on-ok="disableStuOk"
        >
            <div style="padding-left: 40px">
                <Upload style="display: inline-block"
                        :action="baseUri+'api-user/uc/trainclass/'+stu_class_id+'/stus?access_token='+access_token"
                        name="student_file"
                        :format="['xls','xlsx']"
                        :on-format-error="excelFormatError"
                        :on-error="excelErr"
                        :on-success="excelSuccess" >
                    <Button type="primary" @click="batchImportModel = true">文件选择</Button>
                </Upload>
            </div>
        </Modal>
        <Modal
                v-model="addStuModel"
                title="添加学生"
                :mask-closable="false"
                :loading="loading"
                @on-ok="addStu('addStuForm')"
        >
            <div>
                <Form ref="addStuForm" :model="addStuForm" :rules="addStuValidate" :label-width="100">
                    <FormItem label="学生名称" prop="nickname">
                        <Input v-model="addStuForm.nickname" placeholder="请输入学生名称" style="width: 200px"></Input>
                    </FormItem>
                    <FormItem label="学生账号" prop="username">
                        <Input v-model="addStuForm.username" placeholder="请输入学生账号" style="width: 200px">
                            <span slot="append">@{{user_info.schoolDomain}}</span>
                        </Input>
<!--                        <Input v-model="addStuForm.username" placeholder="请输入学生账号" style="width: 200px"></Input>-->
                    </FormItem>
                    <FormItem label="是否禁用" prop="enabled">
                        <i-switch size="large" v-model="addStuForm.enabled">
                            <span slot="open" :value="true">启用</span>
                            <span slot="close" :value="false">禁用</span>
                        </i-switch>
                    </FormItem>
                    <FormItem label="初始密码" prop="password">
                        <Input v-model="addStuForm.password" placeholder="请输入密码" style="width: 200px" maxlength="20" type="password"></Input>
                        <p class="ipt-tip">6-20位字母数字组合密码</p>
                    </FormItem>
                </Form>
            </div>
        </Modal>
        <Modal
                v-model="resetAdminPwdModel"
                title="重置教管密码"
                @on-ok="ok"
        >
            <div>
                <Form ref="resetPwdForm" :model="resetAdminPwdForm"  :label-width="120">
                    <FormItem label="名称" prop="stuName" style="margin-bottom: 10px">
                        {{resetAdminPwdForm.stuName}}
                    </FormItem>
                    <FormItem label="新密码" style="margin-bottom: 10px">
                        <Input v-model="resetAdminPwdForm.newPassword" placeholder="请输入新密码" style="width: 240px"></Input>
                    </FormItem>
                    <FormItem label="重新输入新密码" style="margin-bottom: 10px">
                        <Input v-model="resetAdminPwdForm.Password" placeholder="再次输入密码" style="width: 240px"></Input>
                        <p class="ipt-tip">8-16个字符，必须同时包含数字、大小写字母、特殊字符</p>
                    </FormItem>
                </Form>
            </div>
        </Modal>
        <Modal
                v-model="resetLabPwdModel"
                title="重置实验密码"
                @on-ok="ok"
        >
            <div>
                <Form ref="resetPwdForm" :model="resetLabPwdForm"  :label-width="120">
                    <FormItem label="名称" prop="stuName" style="margin-bottom: 10px">
                        {{resetLabPwdForm.stuName}}
                    </FormItem>
                    <FormItem label="新密码" style="margin-bottom: 10px">
                        <Input v-model="resetLabPwdForm.newPassword" placeholder="请输入新密码" style="width: 240px"></Input>
                    </FormItem>
                    <FormItem label="重新输入新密码" style="margin-bottom: 10px">
                        <Input v-model="resetLabPwdForm.Password" placeholder="再次输入密码" style="width: 240px"></Input>
                        <p class="ipt-tip">8-16个字符，必须同时包含数字、大小写字母、特殊字符</p>
                    </FormItem>
                </Form>
            </div>
        </Modal>
        <Modal
                v-model="editModel"
                title="修改学生"
                :mask-closable="false"
                :loading="loading"
                @on-ok="edit('editStuForm')"
        >
            <div>
                <Form ref="editStuForm" :model="editStuForm" :rules="editStuValidate" :label-width="120">
                    <FormItem label="学生名称" prop="nickname">
                        <Input v-model="editStuForm.nickname" placeholder="请输入学生名称" style="width: 200px"></Input>
                    </FormItem>
                    <FormItem label="学生账号" prop="username">
                        <Input v-model="editStuForm.username" placeholder="请输入学生账号" style="width: 200px">
                            <span slot="append">@{{user_info.schoolDomain}}</span>
                        </Input>
                    </FormItem>
                    <FormItem label="是否禁用" prop="enabled">
                        <i-switch size="large" v-model="editStuForm.enabled">
                            <span slot="open" :value="true">启用</span>
                            <span slot="close" :value="false">禁用</span>
                        </i-switch>
                    </FormItem>
                </Form>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {authApi} from '@/api/base.js'
    import cookie from "vue-cookies";
    import {mapActions, mapState} from 'vuex'
    export default {
        name: "stuList",
        props:{
            stu_class_id:Number,
        },
        data(){
            const validateEnabled = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择是否启用禁用！'));
                } else{
                    callback();
                }
            };
            //密码校验
            const validatePwd = (rule, value, callback) => {
                let reg = /(?=.*[0-9])(?=.*[a-zA-Z]).{6,20}/;
                if (value === '') {
                    callback(new Error('密码不能为空！'));
                } else if(!reg.test(value)){
                    callback(new Error('密码必须包含字母、数字的6-20位数！'));

                }else{
                    callback();
                }
            };
            return{
                addStuModel:false,
                batchImportModel:false,
                delStuModel:false,
                resetLabPwdModel:false,
                resetAdminPwdModel:false,
                editModel:false,
                loading:true,
                del_cur_stuid:null,
                cur_stuid:null,
                download_template:`${authApi}api-user/uc/trainclass/stu/download_template?access_token=${cookie.get('session')}`,
                baseUri:authApi,
                access_token:cookie.get('session'),
                addStuForm:{
                    nickname:'',
                    username:'',
                    enabled:true,
                    password:'',
                },
                page_num:1,
                page_size:20,
                editStuForm:{
                    nickname:'',
                    username:'',
                    enabled:true,
                },
                resetAdminPwdForm:{
                    stuName:'',
                    newPassword:'',
                    Password:''
                },
                resetLabPwdForm:{
                    stuName:'',
                    newPassword:'',
                    Password:''
                },
                addStuValidate: {
                    nickname: [
                        {required: true, message: '学生姓名不能为空', trigger: 'blur'}
                    ],
                    username: [
                        {required: true, message: '学生账号不能为空', trigger: 'blur'}
                    ],
                    enabled: [
                        {required: true,validator: validateEnabled, trigger: 'change'},
                    ],
                    password: [
                        {required: true, validator: validatePwd, trigger: 'blur'}
                    ],
                },
                editStuValidate: {
                    nickname: [
                        {required: true, message: '学生姓名不能为空', trigger: 'blur'}
                    ],
                    username: [
                        {required: true, message: '学生账号不能为空', trigger: 'blur'}
                    ],
                    enabled: [
                        {required: true,validator: validateEnabled, trigger: 'change'},
                    ],
                },
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'ID',
                        key: 'id',
                        sortable: true
                    },
                    {
                        title: '姓名',
                        key: 'nickname'
                    },
                    {
                        title: '学生账号',
                        key: 'username'
                    },
                    {
                        title: '状态',
                        key: 'enabled',
                        render: (h, params) => {
                            return h('div', [
                                h('Icon', {
                                    style: {
                                        marginRight: '5px',
                                        color:params.row.enabled ? '#42b983':'red'
                                    },
                                    props:{
                                        type:params.row.enabled?'md-checkmark-circle':'ios-close-circle'
                                    },
                                    on: {
                                        click: () => {
                                            this.disableStu(params.row)
                                        }
                                    }
                                }, '禁用'),
                                h('span', {

                                }, params.row.enabled ? '启用':'禁用'),
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        render: (h, params) => {
                            return h('div', [
                                // h('a', {
                                //     style: {
                                //         marginRight: '5px',
                                //         color:'#029ff6'
                                //     },
                                //     on: {
                                //         click: () => {
                                //             this.disableStu(params.row)
                                //         }
                                //     }
                                // }, '禁用'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.editStuRow(params.row)
                                        }
                                    }
                                }, '编辑'),
                                // h('a', {
                                //     style: {
                                //         marginRight: '5px',
                                //         color:'#029ff6'
                                //     },
                                //     on: {
                                //         click: () => {
                                //             this.resetAdminPwd(params.row)
                                //         }
                                //     }
                                // }, '重置教管密码'),
                                // h('a', {
                                //     style: {
                                //         marginRight: '5px',
                                //         color:'#029ff6'
                                //     },
                                //     on: {
                                //         click: () => {
                                //             this.resetLabPwd(params.row)
                                //         }
                                //     }
                                // }, '重置实验密码'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.deleteRow(params)
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    },
                ],
                stuTableSelect:[]
            }
        },
        computed: {
            ...mapState({
                train_class_stu: state => state.classAndStu.train_class_stu,
                user_info: state => state.loginState.user_info,
            }),
        },
        methods:{
            ...mapActions({
                getTrainClassStu: 'classAndStu/getTrainClassStu',
                addTrainClassStu: 'classAndStu/addTrainClassStu',
                batchDelStu:'classAndStu/batchDelStu',
                delStuApi:'classAndStu/delStu',
                editTrainClassStu:'classAndStu/editTrainClassStu'
            }),
            delStu(){
                let _this = this
                if(this.checkTableSelect('请选择要删除的学生！')){
                    this.batchDelStu({
                        ids:_this.stuTableSelect,
                        callback:res =>{
                            _this.$Message.success('删除成功！')
                            _this.initTrainClassStu()
                        }
                    })

                }
            },
            excelFormatError(file){
                this.$Message.error('文件格式错误，请上传正确的excel格式文件！');
            },
            excelSuccess(response,file){
                if (response.status.code == 2000000) {
                    this.$Message.success(response.status.message)
                    this.initTrainClassStu()
                }else{
                    this.$Message.error(response.status.message)
                }
            },
            excelErr(response,file){
                this.$Message.error(file.message)
            },
            disableStuOk(){

            },
            disableStu(){
                this.disableModel = true
            },
            //删除单个学生
            deleteRow(row){
                let _this = this
                this.del_cur_stuid = row.row.id
                this.$Modal.warning({
                    title: `删除学生${row.row.nickname}`,
                    content: '确认要删除此数据吗？删除后不可恢复！',
                    onOk:function(){
                        _this.delStuApi({
                            stu_id:row.row.id,
                            callback:res =>{
                                _this.$Message.success('删除成功！')
                                _this.initTrainClassStu()
                            }
                        })
                    }
                });
            },
            batchImport(){

            },
            checkTableSelect(msg){
                if(this.stuTableSelect.length == 0){
                    this.$Message.error(msg);
                    return false
                }
                return true
            },
            // tableSelect(row){
            //     console.log(row)
            //     this.stuTableSelect.push(row.id)
            // },
            tableSelectAll(row){
                let arr = []
                row.forEach(item =>{
                    let numberId = parseInt(item.id)
                    arr.push(numberId)
                })
                this.stuTableSelect = arr
            },
            ok(){

            },
            edit(name){
                let _this = this
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        _this.editTrainClassStu({
                            data:_this.editStuForm,
                            stu_id:_this.cur_stuid,
                            callback:res =>{
                                _this.$Message.success('编辑学生成功！')
                                _this.editModel = false
                                _this.initTrainClassStu()
                            },
                            err:msg=>{
                                _this.$Message.error(msg)
                            }
                        })
                    } else {
                        return this.changeLoading();
                    }
                })
            },
            changeLoading() {
                this.loading = false;
                this.$nextTick(() => {
                    this.loading = true;
                });
            },
            //新增学生
            addStu(name){
                let _this = this
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        _this.addTrainClassStu({
                            data:_this.addStuForm,
                            class_id:_this.stu_class_id,
                            callback:res =>{
                                _this.$Message.success('新增学生成功！')
                                _this.addStuModel = false
                                _this.initTrainClassStu()
                            },
                            err:msg=>{
                                _this.$Message.error(msg)
                            }
                        })
                    } else {
                        return this.changeLoading();
                    }
                })
            },
            resetAddStuForm (name) {
                this.$refs[name].resetFields();
            },
            //编辑学生
            editStuRow(row){
                this.editModel = true
                this.cur_stuid = row.id
                this.editStuForm = {
                    nickname:row.nickname,
                    username:row.username.split('@')[0],
                    enabled:row.enabled,
                }
            },
            //重置教管密码
            resetAdminPwd(row){
                this.resetAdminPwdModel = true
                this.resetAdminPwdForm.stuName = row.name

            },
            //重置实验密码
            resetLabPwd(row){
                this.resetLabPwdModel = true
                this.resetLabPwdForm.stuName = row.name
            },
            currentPage(num){
                this.page_num = num
                this.initTrainClassStu()
            },
            pageSizeChange(size){
                this.page_size = size
                this.initTrainClassStu()
            },
            initTrainClassStu(){
                let _this = this
                this.getTrainClassStu({
                    data:{
                        sort:'-name|ctime',
                        page_num:_this.page_num,
                        page_size:_this.page_size
                    },
                    class_id:_this.stu_class_id
                })
            }
        },
        mounted () {
            this.initTrainClassStu()
        },
    }
</script>

<style scoped lang="less">
    @import "../../style/index";

</style>
